// Custom Procurify AI icon (not Lucide): assets/MagicSolid.svg
import { ReactComponent as Icon } from '../assets/MagicSolid.svg'
import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMagicSolid = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Icon />
    </IconComponentStyled>
  )
}
